import { useState } from "react";
import "./login.css";
import { TfiEmail } from "react-icons/tfi";
import { BsFillKeyFill } from "react-icons/bs";
import { SyncLoader } from "react-spinners";
import validator from "email-validator";
import { Button, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import LoginService from "../../services/Login";

export const Login = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [formInput, setFormInput] = useState({ email: "", password: "" });
  const [ValidColor, setColor] = useState("rgb(21,95,93)");
  const [isLoading, setIsLoading] = useState(false);
  const style = {
    fontSize: "24px",
    width: "15%",
    color: "rgb(233,193,77)",
  };

  const handleChange = (e: any) => {
    if (e.target.name === "username") {
      if (validator.validate(e.target.value)) {
        setColor("rgb(21,95,93)");
      } else {
        setColor("red");
      }
    }
    setFormInput({ ...formInput, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    LoginService.login(formInput)
      .then((response: any) => {
        if (response.data.success) {
          setIsLoading(false);
          localStorage.setItem("logged_in_email", formInput.email);
          localStorage.setItem("logged_in_User", "true");
          localStorage.setItem("logged_in_user_token", response.data.token);
          localStorage.setItem("logged_in_user_type", response.data.access);
          localStorage.setItem(
            "logged_in_user_permissions",
            JSON.stringify(response.data.persmissions)
          );
          localStorage.setItem(
            "logged_in_user_accesscontrols",
            JSON.stringify(response.data.accessControls)
          );
          localStorage.setItem("logged_in_user_id", response.data.userId);

          toast({
            position: "top",
            title: "Login Successfull.",
            description: "You logged in successfully.",
            status: "success",
            duration: 500,
            isClosable: true,
          });
          navigate("/welcome");
        } else {
          setIsLoading(false);
          toast({
            position: "top",
            title: "Login Failed.",
            description: "Username or password is incorrect.",
            status: "error",
            duration: 1000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast({
          position: "top",
          title: "Login Failed.",
          description: "Username or password is incorrect.",
          status: "error",
          duration: 1000,
          isClosable: true,
        });
      });
    setFormInput({ email: "", password: "" });
  };

  return (
    <div className="login-container">
      <img src={"/img/logo.png"} alt="logo" />

      <h1>Login</h1>

      <form>
        <label htmlFor="">Username</label>
        <div
          style={
            ValidColor === "red"
              ? { border: `1px solid ${ValidColor}`, backgroundColor: "#fff" }
              : {
                  border: `1px solid ${ValidColor}`,
                  backgroundColor: "rgb(21,95,93)",
                }
          }
        >
          <TfiEmail
            style={
              ValidColor === "red"
                ? { fontSize: "24px", width: "15%", color: "red" }
                : { fontSize: "24px", width: "15%", color: "rgb(233,193,77)" }
            }
          />
          <input
            type="text"
            name="email"
            value={formInput.email}
            onChange={handleChange}
          />
        </div>

        <label htmlFor="">Password</label>
        <div>
          <BsFillKeyFill style={style} />
          <input
            type="password"
            name="password"
            value={formInput.password}
            onChange={handleChange}
          />
        </div>
        <Button
          width="50%"
          color="rgb(233,193,77)"
          onClick={handleSubmit}
          backgroundColor="rgb(21,95,93)"
          disabled={
            formInput.email === "" ||
            formInput.password === "" ||
            ValidColor === "red"
              ? true
              : false
          }
        >
          {isLoading ? <SyncLoader color="#36d7b7" size="10" /> : "Submit"}
        </Button>
      </form>
    </div>
  );
};
